
import LayoutFooter from './Footer.vue'
import LayoutNavigation from './Navigation.vue'
export default {
  name: 'Layout',
  components: { LayoutNavigation, LayoutFooter },
  props: {
    primary: {
      type: String,
      default: 'primary'
    },
    secondary: {
      type: String,
      default: 'secondary'
    }
  },
  computed: {
    theme() {
      return {
        primary: this.primary,
        secondary: this.secondary
      }
    }
  }
}
